import datePicker from '@assets/image/datePicker.svg';
import { DatePicker } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import './index.scss';
const { RangePicker } = DatePicker;
const ZeissRangePicker = (props: RangePickerProps): any => {
  return (
    <RangePicker
      className="zeiss-reset-datePicker"
      style={{ width: '100%' }}
      suffixIcon={<img src={datePicker} />}
      {...props}
    />
  );
};

export default ZeissRangePicker;
